(() => {
  if (!document.documentElement) return;
  if (!document.body) return;

  // Avoid doubling up on configurator products (they already have a sticky bar).
  if (document.querySelector('[data-jr-configurator]')) return;

  const productInfo = document.querySelector('product-info') || document.querySelector('.product');
  if (!productInfo) return;

  const productForm =
    document.querySelector('product-form form[action*="/cart/add"]') ||
    document.querySelector('form[action*="/cart/add"]') ||
    document.querySelector('form[action*="cart/add"]');
  if (!productForm) return;

  const submitBtn =
    productForm.querySelector('.product-form__submit') ||
    productForm.querySelector('button[name="add"][type="submit"]') ||
    productForm.querySelector('button[type="submit"]');
  if (!(submitBtn instanceof HTMLElement)) return;

  const titleEl = productInfo.querySelector('.product__title h1') || document.querySelector('h1');
  const getTitle = () => String(titleEl ? titleEl.textContent || '' : '').trim();

  const getPriceText = () => {
    const priceRoot =
      productInfo.querySelector('[id^="price-"]') ||
      productInfo.querySelector('.price') ||
      document.querySelector('[id^="price-"]');

    if (!priceRoot) return '';

    const clean = (t) => String(t || '').trim().replace(/\s+/g, ' ');
    const pick = (selector) => {
      const el = priceRoot.querySelector(selector);
      const text = el ? clean(el.textContent) : '';
      return text;
    };

    // Dawn always renders both regular + sale containers; choose based on state.
    const isOnSale = priceRoot.classList.contains('price--on-sale') || priceRoot.classList.contains('volume-pricing--sale-badge');
    let text = '';

    if (isOnSale) {
      text =
        pick('.price__sale .price-item--sale.price-item--last') ||
        pick('.price__sale .price-item--sale') ||
        pick('.price-item--sale.price-item--last') ||
        pick('.price-item--sale');
    } else {
      text = pick('.price__regular .price-item--regular') || pick('.price-item--regular');
    }

    if (text) return text;

    // Fallback: pick the first non-empty price-item text.
    const candidates = Array.from(priceRoot.querySelectorAll('.price-item'))
      .filter((el) => el instanceof HTMLElement && !el.classList.contains('visually-hidden'))
      .map((el) => clean(el.textContent))
      .filter(Boolean);

    if (candidates.length > 0) return candidates[0];

    return clean(priceRoot.textContent);
  };

  const getSelectionText = () => {
    const variantTitle =
      productInfo.querySelector('[data-selected-variant-title]') ||
      productInfo.querySelector('[data-product-title]') ||
      null;
    const direct = variantTitle ? String(variantTitle.textContent || '').trim() : '';
    if (direct) return direct;

    try {
      const radios = Array.from(productInfo.querySelectorAll('variant-radios fieldset'))
        .map((fs) => {
          const checked = fs.querySelector('input[type="radio"]:checked');
          return checked ? String(checked.value || '').trim() : '';
        })
        .filter(Boolean);

      if (radios.length > 0) return radios.join(' / ');

      const selects = Array.from(productInfo.querySelectorAll('variant-selects select'))
        .map((sel) => {
          if (!(sel instanceof HTMLSelectElement)) return '';
          const opt = sel.selectedOptions && sel.selectedOptions[0] ? sel.selectedOptions[0] : null;
          return String((opt ? opt.textContent : sel.value) || '').trim();
        })
        .filter(Boolean);

      if (selects.length > 0) return selects.join(' / ');
    } catch {
      // ignore
    }

    return '';
  };

  const sticky = document.createElement('div');
  sticky.className = 'jr-sticky-cta';
  sticky.setAttribute('data-jr-pdp-sticky', '1');
  sticky.hidden = true;

  sticky.innerHTML = `
    <div>
      <div class="jr-sticky-cta__title"></div>
      <div class="jr-sticky-cta__meta">
        <span data-jr-pdp-sticky-selection></span>
        <span class="jr-sticky-cta__price" data-jr-pdp-sticky-price></span>
      </div>
    </div>
    <button type="button" class="button jr-sticky-cta__button" data-jr-pdp-sticky-add>
      <span data-jr-pdp-sticky-btn-label>Add to cart</span>
      <span class="jr-sticky-cta__button-price" data-jr-pdp-sticky-btn-price></span>
    </button>
  `;

  document.body.appendChild(sticky);

  const titleOut = sticky.querySelector('.jr-sticky-cta__title');
  const selectionOut = sticky.querySelector('[data-jr-pdp-sticky-selection]');
  const priceOut = sticky.querySelector('[data-jr-pdp-sticky-price]');
  const addBtn = sticky.querySelector('[data-jr-pdp-sticky-add]');
  const addBtnLabelOut = sticky.querySelector('[data-jr-pdp-sticky-btn-label]');
  const addBtnPriceOut = sticky.querySelector('[data-jr-pdp-sticky-btn-price]');

  const updateContent = () => {
    if (titleOut) titleOut.textContent = getTitle();
    const priceText = getPriceText();
    if (priceOut) priceOut.textContent = priceText;
    if (addBtnPriceOut) addBtnPriceOut.textContent = priceText;
    if (selectionOut) selectionOut.textContent = getSelectionText();

    // Mirror disabled state / label from the real submit button.
    if (addBtn instanceof HTMLButtonElement) {
      const disabled = submitBtn.hasAttribute('disabled') || submitBtn.getAttribute('aria-disabled') === 'true';
      addBtn.disabled = disabled;
      const label = submitBtn.querySelector('span') ? submitBtn.querySelector('span').textContent : submitBtn.textContent;
      const cleaned = String(label || 'Add to cart').trim().replace(/\s+/g, ' ');
      if (addBtnLabelOut) addBtnLabelOut.textContent = cleaned;
      else addBtn.textContent = cleaned;
    }
  };

  updateContent();

  // Submit via the real button so Dawn's ProductForm logic runs.
  if (addBtn instanceof HTMLElement) {
    addBtn.addEventListener('click', () => {
      if (submitBtn.hasAttribute('disabled')) {
        submitBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      submitBtn.click();
    });
  }

  const scrolledEnough = () => {
    const max = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
    return window.scrollY / max >= 0.2;
  };

  let isPrimaryCtaVisible = true;

  const refreshVisibility = () => {
    const shouldShow = scrolledEnough() && !isPrimaryCtaVisible;
    sticky.hidden = !shouldShow;
    document.body.classList.toggle('jr-has-sticky-cta', shouldShow);
  };

  window.addEventListener('scroll', refreshVisibility, { passive: true });
  window.addEventListener('resize', refreshVisibility);

  try {
    if ('IntersectionObserver' in window && submitBtn instanceof HTMLElement) {
      const obs = new IntersectionObserver(
        (entries) => {
          isPrimaryCtaVisible = entries.some((e) => e && e.isIntersecting);
          refreshVisibility();
        },
        { root: null, threshold: 0.05 }
      );
      obs.observe(submitBtn);
    }
  } catch {
    // ignore
  }

  // Keep in sync when variants change.
  const hookVariantChanges = () => {
    try {
      if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
        window.subscribe(window.PUB_SUB_EVENTS.variantChange, () => {
          window.setTimeout(updateContent, 0);
        });
        return;
      }
    } catch {
      // ignore
    }

    // Fallback: listen for the custom event name (Dawn also defines it as 'variant-change').
    document.addEventListener('variant-change', () => window.setTimeout(updateContent, 0));
  };
  hookVariantChanges();

  // Watch for submit button state/text changes too.
  try {
    const mo = new MutationObserver(() => updateContent());
    mo.observe(submitBtn, { attributes: true, childList: true, subtree: true });
  } catch {
    // ignore
  }

  refreshVisibility();
})();
